module.exports = __webpack_public_path__ + "img/Aura_lightning.2df5fe47.png";